import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { DialogModule } from 'primeng/dialog';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { RadioButtonModule } from 'primeng/radiobutton';
import { TooltipModule } from 'primeng/tooltip';
import { DuplicateLeadMergeComponent } from './duplicate-lead-merge.component';

/**
 * Self-contained feature module for the Duplicate Lead Review + Merge workflow.
 * Import it wherever the modal needs to be opened (edit-lead-detail v1/v2, the
 * leads list, etc.) and drop `<app-duplicate-lead-merge>` into the template.
 *
 * Services (comparison / merge / store) are provided at the component level, so
 * every modal instance owns isolated state — nothing leaks into root DI.
 */
@NgModule({
  declarations: [DuplicateLeadMergeComponent],
  imports: [CommonModule, FormsModule, NgSelectModule, DialogModule, OverlayPanelModule, RadioButtonModule, TooltipModule],
  exports: [DuplicateLeadMergeComponent],
})
export class DuplicateLeadMergeModule {}
